import { DateTime } from 'luxon';

export const utcToJSDate = (date?: string | Date): Date | undefined => {
  if(!date) return undefined;

  return DateTime.fromISO(date, { zone: 'utc' }).toJSDate();
};

export const jsDateToZone = (date?: Date, zoneId?: string, format?: string): string => {
  // console.log('jsDateToZone', date, zoneId);
  format = format || 'yyyy-MM-dd HH:mm';
  
  if(!date) return '-';
  
  if(!zoneId){
    return 'UTC: ' + DateTime.fromJSDate(date).setZone('utc').toFormat(format);
  }

  return DateTime.fromJSDate(date).setZone(zoneId).toFormat(format);
};

export function timeStringToJsDate(time: string): Date {
    const [hours, minutes, seconds] = time.split(':').map(Number);
    const date = new Date();
    date.setHours(hours, minutes, seconds, 0);
    return date;
}  
export function jsDateToTimeString(date: Date): string {
    return date.toLocaleTimeString('en-GB', { hour12: false });
}  